<template>
  <div class="input-wrapper" :class="{ showFormError: 'error' }">
    <p class="input--title" v-if="label">{{ label }}</p>
    <p class="field-description" v-if="fieldData.description" v-html="fieldData.description"/>
    <div class="input-radio" v-for="(option, index) in fieldData.options" :key="`${fieldData.name}-${index}`">
      <label class="checkbox-container radio-container">
      <input
        type="radio"
        :id="fieldData.name + option.value"
        :name="fieldData.name"
        :value="option.value"
        v-model="value"
      />
      {{ option.label }}
      <span class="checkmark circle"></span>
      </label>
      <p class="forms__error-message" v-if="showFormError" v-t="'errors.required_field'" role="alert"/>
    </div>
  </div>
</template>

<script>
import AbstractField from "@/util/AbstractField";

export default {
  name: "radios",
  mixins: [AbstractField],
};
</script>